<template>
	<highcharts :options="reformatOptions"></highcharts>
</template>
<script>
import ChartHelper from 'Mixins/ChartHelper'
export default {
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	mixins: [ChartHelper],
	data() {
		return {}
	},
	computed: {
		reformatOptions() {
			let roast = this.roast(this.options)
			let chartOptions = {
				...roast,
				chart: {
					type: 'spline',
					inverted: false,
					polar: false
				}
			}
			return chartOptions
		}
	}
}
</script>
